module.exports = __webpack_public_path__ + "static/media/joined-icon.a26bc361.svg";